interface BlogData {
  title: string;
  url: string;
  post: number;
  text: string[];
  tags: string[];
}

type BlogJsonFile = {
  title: string;
  url: string;
  post: number;
  text: string[];
  tags: string[];
};

type WebpackContext = {
  (key: string): BlogJsonFile;
  keys: () => string[];
};

export function getBlogData(locale: string): BlogData[] {
  let blogContext: WebpackContext;

  switch (locale) {
    case "nl":
      blogContext = require.context(
        "../../public/locales/nl/blog",
        true,
        /\.json$/
      );
      break;
    case "gb":
      blogContext = require.context(
        "../../public/locales/gb/blog",
        true,
        /\.json$/
      );
      break;
    // ... Handle other locales
    default:
      blogContext = require.context(
        "../../public/locales/nl/blog",
        true,
        /\.json$/
      ); // default to nl if no match
      break;
  }

  const blogData: BlogData[] = [];
  blogContext.keys().forEach((fileName: string) => {
    try {
      const blogJson = blogContext(fileName);
      const title = blogJson.title;
      const url = blogJson.url;
      const post = blogJson.post;
      const text = blogJson.text;
      // const tags = blogJson.tags;

      blogData.push({
        title,
        url,
        post,
        text,
        tags: blogJson.tags || [] // default to an empty array if no tags are present
      });
    } catch (error) {
      console.error(`Error parsing ${fileName}:`, error);
    }
  });

  return blogData;
}
